import { API_PAYMENT_MODES_CONFIGURABLES } from "../../utils/apis";
import { getRegister } from "../../utils/helpers";
import { URL_PAYMENT_MODES_CONFIGURABLES } from "../../utils/urls";

export const usePaymentModesConfigurablesForm = () => {
  const sections = [
    {
      title: "Configurable Details",
      fields: [
        {
          field_name: "mode",
          type: "text",
          label: "Payment Mode",
          props: { required: true },
        },
        {
          field_name: "description",
          type: "textarea",
          label: "Description",
          props: { required: true },
        },
      ],
    },
  ];

  const redirect = getRegister(URL_PAYMENT_MODES_CONFIGURABLES);

  return {
    sections,
    redirect,
  };
};

export function submitPaymentModesConfigurables(payload: any, id: string) {
  //  on update
  if (id) {
    return {
      id,
      api: API_PAYMENT_MODES_CONFIGURABLES,
      params: payload,
    };
  }
  // on create
  return {
    api: API_PAYMENT_MODES_CONFIGURABLES,
    params: payload,
  };
}
